export const labels = {
    small: 'text-xs uppercase txt-c2 tracking-wide',
    data: 'font-bold',
    rmaTitle: 'block text-xl leading-tight font-normal',
    itemName: 'text-base leading-tight',
    thead: 'sticky pin-t z-10 bg-near-white text-sm txt-c2 font-bold',
    badge: 'font-normal badge-hollow text-xs uppercase',
    step: 'border-2 text-brand border-solid font-bold h-8 w-8 inline-flex flex-no-shrink items-center justify-center rounded-full text-base'
};

export const space = {
    th: 'px-4 py-3',
    td: 'mt-2 md:m-0 md:px-4 md:py-3'
};

export const box = {
    divider: 'border-b border-solid border-grey-lightest',
    info: 'px-4 py-2 text-sm txt-c2 bg-near-white text-left border-l-2 border-solid border-sky-blue'
};

export const nav = {
    container: 'flex relative mt-4 justify-between md:justify-start text-center lg:text-left',
    link: 'px-1 md:mr-8 pb-1 border-b-4 border-transparent border-solid hover:border-brand',
    cardLink: 'px-4 py-3 flex items-center justify-between leading-collapse border-grey-lightest border-solid border-t hover:bg-near-white'
};
